import { render } from "./goodList.vue?vue&type=template&id=b4df6fce"
import script from "./goodList.vue?vue&type=script&lang=js"
export * from "./goodList.vue?vue&type=script&lang=js"
script.render = render

export default script